<template>
	<div>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group" role="group" aria-label="...">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<h4 class="modal-title">Tipo de documento</h4>
					</div>
					<div class="list-group m-b-0">
						<button @click="addCustomer()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-address-card-o fa-fw"></i>
							Cliente
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addBudget()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
							Presupuesto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addOrder()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-file-text"></i>
							Pedido
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addInvoice()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-clipboard"></i>
							Factura
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addProject()" type="button" class="list-group-item">
							<i class="fa fa-folder-o" aria-hidden="true"></i>
							Proyecto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addProduct()" type="button" class="list-group-item">
							<i class="fa fa-cube fa-fw" aria-hidden="true"></i>
							Producto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addAgreement()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-handshake-o"></i>
							Contrato
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<create-order
			@reload="reload"
			ref="createOrder"
			:user="user"
			:isAuth="isAuth">
		</create-order>

		<create-invoice
			@reload="reload"
			ref="createInvoice"
			:user="user"
			:isAuth="isAuth">
		</create-invoice>

		<create-project
			@reload="reload"
			@createTask="openTaskCreate"
			ref="createProject"
			:user="user"
			:isAuth="isAuth">
		</create-project>

		<task-create
			ref="taskCreate"
			@openCreateSchedule="openCreateSchedule"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			ref="schedulecreate"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>

		<agreement-create
			ref="createAgreement"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</agreement-create>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	import CreateOrder from '@/components/management/orders/views/Create.vue'
	import CreateInvoice from '@/components/management/invoices/views/Create.vue'
	import CreateProject from '@/components/projects/projects/views/Create.vue'
	import TaskCreate from '@/components/projects/tasks/views/Create.vue'
	import ScheduleCreate from '@/components/projects/schedules/views/Create.vue'
	import AgreementCreate from '@/components/agreements/views/Create.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'create-order': CreateOrder,
			'create-invoice': CreateInvoice,
			'create-project': CreateProject,
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
			'agreement-create': AgreementCreate,
		},
		data () {
			return {
				modal: {
					selector: 'modal-add-resource-customer'
				},
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			//--
			editOrContinue(response, type) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					if(type == 'budget') {
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
					} else if(type == 'order'){
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + response.body.data.id + '/edit')
					} else if(type == 'invoice') {
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/invoices/' + response.body.data.id + '/edit')
					}
				}).catch(swal.noop)
			},
			addCustomer() {
				this.close()
				this.$router.push('management/customers/create')
			},
			addBudget() {
				this.close()
				var that = this
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets')
							.then(response => {
								that.$emit('reload')
								that.editOrContinue(response, 'budget')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			addOrder() {
				this.close()
				this.$refs.createOrder.open()
			},
			addInvoice() {
				this.close()
				this.$refs.createInvoice.open()
			},
			addProject() {
				this.close()
				this.$refs.createProject.open()
			},
			addProduct() {
				this.close()
				this.$router.push('management/products/create')
			},
			addAgreement() {
				this.close()
				this.$refs.createAgreement.open()
			},
			//--
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/dashboard/views/Add.vue